import VisualSubtraction from "../../components/ClassOne/Mathematics/VisualSubtraction";
import WordSubtraction from "../../components/ClassOne/Mathematics/WordSubtraction";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/substraction/visual-problem", title: "Visual Problem", component: VisualSubtraction },
    { url: "/class-one/mathematics/substraction/word-problem", title: "Word Problem", component: WordSubtraction },
];

export default topics;